import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchVenmoToken } from '../../../saga/actions/League.action';
import DropIn from "braintree-web-drop-in-react";
 
class VenmoPayment extends React.Component {
  instance;
 
  state = {
    clientToken: null,
  };
 
  async componentDidMount() {
      this.props.fetchVenmoToken();
      
    // Get a client token for authorization from your server
    //  const response = await fetch("server.test/client_token");
    // //const clientToken = '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' // If returned as JSON string
    // const clientToken = localStorage.getItem('venmoToken')
    // this.setState({
    //   clientToken,
    // });
  }

  componentWillReceiveProps(nextProps)
  {
    if(nextProps.leaguePayment.venmoToken)
    {
        this.setState({
            clientToken : nextProps.leaguePayment.venmoToken.clientToken
        });
      nextProps.leaguePayment.venmoToken= ''
    }
  }
 
  async buy(e) {
    e.preventDefault();
    // Send the nonce to your server
    localStorage.removeItem('venmoToken')
    const { nonce } = await this.instance.requestPaymentMethod();
    this.props.sendNanceTokenToServer(nonce);
    // await fetch(`server.test/purchase/${nonce}`);
  }
 
  render() {
    if (!this.state.clientToken) {
      return (
        <div>
          <h1>Loading...</h1>
        </div>
      );
    } else {
      return (
        <div>
          <DropIn
            options={{ authorization: this.state.clientToken }}
            onInstance={(instance) => (this.instance = instance)}
          />
          <button onClick={this.buy.bind(this)}>Pay</button>
        </div>
      );
    }
  }
}
// export default VenmoPayment;

VenmoPayment.propTypes = {
    fetchVenmoToken: PropTypes.func.isRequired,
  };
  
  const mapStateToProps = state => ({
    leaguePayment: state.league
  });
  
  export default connect(mapStateToProps, { fetchVenmoToken })(VenmoPayment);